module.exports = __webpack_public_path__ + "static/media/wheel-alignment.800835e6.svg";